import debug from 'debug';
const log = debug('recaptcha-presubmit');

class RecaptchaPresubmit {
	constructor(element, options) {
		log('element', element);
		log('options', options);

		this.options = options;
		this.form = element;

		this.recaptchaSiteKey = this.options.recaptchaSiteKey;
		this.recaptchaValidationUrl = this.options.recaptchaValidationUrl;
		this.responseInput = this.form.querySelector(
			this.options.responseInputSelector
		);
		this.responseErrorElement = this.form.querySelector(
			this.options.responseErrorSelector
		);
		this.prefix = this.options.sitePrefix;

		this.init(options.isWatching);
	}

	init(isWatching) {
		this.addRecaptchaScript();

		if (isWatching) {
			this.watch();
		}
	}

	watch() {
		this.form.addEventListener('submit', this.onFormSubmit.bind(this));
	}

	// Only called if isWatching is not false
	onFormSubmit(event) {
		log('onFormSubmit', event);
		event.preventDefault();
		this.responseErrorElement.hidden = true;
		window.grecaptcha.ready(this.onRecaptchaReady.bind(this));
	}

	onRecaptchaReady() {
		try {
			return window.grecaptcha
				.execute(this.recaptchaSiteKey, { action: 'submit' })
				.then(this.onRecaptchaResponse.bind(this));
		} catch (error) {
			this.displayValidationError(error.message);
			return Promise.reject(error);
		}
	}

	addRecaptchaScript() {
		if (!window.grecaptcha) {
			const recaptchaScriptEl = document.createElement('script');
			recaptchaScriptEl.src =
				'https://www.google.com/recaptcha/api.js?render=' +
				this.recaptchaSiteKey;
			recaptchaScriptEl.onload = this.onRecaptchaScriptLoaded.bind(this);
			document.body.appendChild(recaptchaScriptEl);
		} else {
			this.onRecaptchaScriptLoaded();
		}
	}

	onRecaptchaScriptLoaded() {
		log('onRecaptchaScriptLoaded');
	}

	requestValidation() {
		return new Promise((resolve, reject) => {
			this.responseErrorElement.hidden = true;
			window.grecaptcha.ready(() => {
				window.grecaptcha
					.execute(this.recaptchaSiteKey, { action: 'submit' })
					.then((token) => {
						resolve(this.onRecaptchaResponse(token));
					})
					.catch((error) => {
						this.displayValidationError(error.message);
						reject(error);
					});
			});
		});
	}

	onRecaptchaResponse(token) {
		const url = new URL(this.recaptchaValidationUrl, window.location.origin);
		url.searchParams.set('token', token);
		url.searchParams.set('prefix', this.prefix);
		log('onRecaptchaResponse', token);

		return fetch(url)
			.then((response) => {
				if (response.ok) {
					return response.json();
				}
				return Promise.reject(response);
			})
			.then(this.onRecaptchaRequestSuccess.bind(this))
			.catch(this.onRecaptchaRequestError.bind(this));
	}

	onRecaptchaRequestSuccess(data) {
		log('onRecaptchaValidationSuccess', data);

		if (data.Success === true) {
			// add data.Result to SessionId field in the form and submit form
			this.responseInput.value = data.Result;
		} else {
			// data.Result contains the error message
			this.displayValidationError(data.Result);
		}
	}

	onRecaptchaRequestError() {
		log('onRecaptchaValidationError');
		// This happens is the API call fails
		this.displayValidationError(
			'Something went wrong. Please reload the page and try again.'
		);
	}

	displayValidationError(errorMessage) {
		log('displayValidationError', errorMessage);
		this.responseErrorElement.hidden = false;

		if(this.options.onErrorEvent) {
			this.form.dispatchEvent(
				new CustomEvent(this.options.onErrorEvent, {
					bubbles: false,
					cancelable: true,
				})
			);
		}
	}
}

RecaptchaPresubmit.DEFAULTS = {
	responseInputSelector: '[data-presubmit-response]',
	responseErrorSelector: '[data-presubmit-error]',
	recaptchaValidationUrl: '/api/recaptcha',
	onErrorEvent: false,
};

export default RecaptchaPresubmit;



// WEBPACK FOOTER //
// ./client/src/core/modules/recaptcha-presubmit/recaptcha-presubmit.js